<ng-container *ngIf="paymentTypesLoading">
	<div class="text-center p-4">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
		<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_MSG_PAYMENT'] }}</p>
	</div>
</ng-container>

<ng-container *ngIf="paymentTypesError">
	<div class="text-center p-4">
		<i class="pi pi-exclamation-triangle text-danger" style="font-size: 2rem"></i>
		<p class="p-error mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_PAYMENT'] }}</p>
	</div>
</ng-container>

<ng-container *ngIf="!paymentTypesLoading && !paymentTypesError">
	<ng-container>
		<div class="horizontal-scroll">
			<div class="flex justify-between items-center mb-3 px-2">
				<!-- Left: Create New button -->
				<button pButton type="button" icon="pi pi-plus"
					label="{{ translateServ.dictionary['CREATE_NEW'] || 'Create New' }}"
					class="p-button-sm p-button-primary" (click)="createNewRecord()"></button>

				<!-- Right: Global filter -->
				<span class="p-input-icon-left">
					<i class="pi pi-search"></i>
					<input type="text" pInputText [(ngModel)]="globalFilter" (input)="applyGlobalFilter()"
						placeholder="{{ translateServ.dictionary['SEARCH'] || 'Search' }}"
						class="p-inputtext-sm" />
				</span>
			</div>

			<p-table 
				#dt 
				*ngIf="paymentTypes && paymentTypes.length > 0; else noPaymentTypes"
				id = "tab_pay_info"
				dataKey="RecID"
				[globalFilterFields]="globalFilterFields" 
				[value]="paymentTypes"
				[totalRecords] = "paymentTypes.length"
				styleClass="app-data-table app-data-table--paged app-data-table--editable p-datatable-sm p-datatable-striped" responsiveLayout="scroll" 
				[paginator]="true" 
				[rows]="getCurrentPageSize(0, paymentTypes.length)"
				[rowsPerPageOptions]="setPaginator(paymentTypes.length)" 
				(onPage) = "onRowsPerPageChange($event,0, paymentTypes.length)"
				[showCurrentPageReport]="true"
				currentPageReportTemplate="{{ translateServ.dictionary['TAB_FOOTER_SHOWING'] }} {first} {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} {{ translateServ.dictionary['MAINT_TABLE_PAYMENTS'] }}"
				[tableStyle]="{'min-width': '78rem', 'table-layout': 'fixed'}" [paginatorDropdownAppendTo]="'body'">
				<ng-template let-item pTemplate="paginatordropdownitem">
					{{ item.value === paymentTypes.length ? 'All' : item.value }}
				</ng-template>
				<!-- HEADER -->
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="RecID" style="width: 6rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_ID'] }}
							<p-sortIcon field="RecID"></p-sortIcon>
						</th>
						<th pSortableColumn="PaymentType" style="width: 10rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_PAY_TYPE'] }}
							<p-sortIcon field="PaymentType"></p-sortIcon>
						</th>
						<th pSortableColumn="PaymentNumber" style="width: 15rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_PAY_NUM'] }}
							<p-sortIcon field="PaymentNumber"></p-sortIcon>
						</th>
						<th pSortableColumn="CreditType" style="width: 12rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_CRED_TYPE'] }}
							<p-sortIcon field="CreditType"></p-sortIcon>
						</th>
						<th pSortableColumn="CreditNumber" style="width: 12rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_CRED_NUM'] }}
							<p-sortIcon field="CreditNumber"></p-sortIcon>
						</th>
						<th pSortableColumn="BankName" style="width: 10rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_BNK_NAME'] }}
							<p-sortIcon field="BankName"></p-sortIcon>
						</th>
						<th pSortableColumn="BankBranch" style="width: 10rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_BNK_BRNC'] }}
							<p-sortIcon field="BankBranch"></p-sortIcon>
						</th>
						<th pSortableColumn="BankCheckNumber" style="width: 10rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_BNK_CHECK_NUM'] }}
							<p-sortIcon field="BankCheckNumber"></p-sortIcon>
						</th>
						<th pSortableColumn="Description" style="width: 12rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_DESC'] }}
							<p-sortIcon field="Description"></p-sortIcon>
						</th>
						<th pSortableColumn="DateEntered" style="width: 10rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_DATE_ENT'] }}
							<p-sortIcon field="DateEntered"></p-sortIcon>
						</th>
						<th pSortableColumn="DateLastUpdated" style="width: 10rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_DATE_LUPD'] }}
							<p-sortIcon field="DateLastUpdated"></p-sortIcon>
						</th>
						<th pSortableColumn="Status" style="width: 8rem;">
							{{ translateServ.dictionary['MAINT_IN_TIT_STAT'] }}
							<p-sortIcon field="Status"></p-sortIcon>
						</th>
						<th pSortableColumn="IsApproved" style="width: 8rem;">
							{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] || 'Approved' }}
							<p-sortIcon field="IsApproved"></p-sortIcon>
						</th>
						<th style="width: 8rem;">
							{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS'] }}
						</th>
					</tr>
				</ng-template>

				<!-- BODY -->
				<ng-template pTemplate="body" let-paymentTypeItem>
					<tr>
						<td>{{ paymentTypeItem.RecID }}</td>
						<td>{{ paymentTypeItem.PaymentType }}</td>
						<td>
							<ng-container *ngIf="paymentTypeItem.PaymentAccountNum">
								{{ paymentTypeItem.PaymentAccountNum }}
							</ng-container>
							<ng-container *ngIf="!paymentTypeItem.PaymentAccountNum && paymentTypeItem.CreditCardNum">
								{{ paymentTypeItem.CreditCardNum }}
							</ng-container>
							<ng-container
								*ngIf="!paymentTypeItem.PaymentAccountNum && !paymentTypeItem.CreditCardNum && paymentTypeItem.bank_account_number">
								{{ paymentTypeItem.bank_account_number }}
							</ng-container>
							<ng-container
								*ngIf="!paymentTypeItem.PaymentAccountNum && !paymentTypeItem.CreditCardNum && !paymentTypeItem.bank_account_number">
								N/A
							</ng-container>
						</td>
						<td>
							{{ paymentTypeItem.CreditCardType || 'N/A' }}
							<ng-container
								*ngIf="paymentTypeItem.CreditCardType && paymentTypeItem.Credit_Card_IsApproved === 1">
								<i class="pi pi-check-circle text-success ml-1" pTooltip="Approved"></i>
							</ng-container>
							<ng-container
								*ngIf="paymentTypeItem.CreditCardType && paymentTypeItem.Credit_Card_IsApproved === 0">
								<i class="pi pi-times-circle text-danger ml-1" pTooltip="Not Approved"></i>
							</ng-container>
						</td>
						<td class="blur-on-hover">{{ paymentTypeItem.CreditCardNum || 'N/A' }}</td>
						<td>{{ paymentTypeItem.bank_name || 'N/A' }}</td>
						<td>{{ paymentTypeItem.bank_branch || 'N/A' }}</td>
						<td>{{ paymentTypeItem.BankCheckNum || 'N/A' }}</td>
						<td>{{ paymentTypeItem.Descr || 'N/A' }}</td>
						<td>{{ paymentTypeItem.DateEntered ? (paymentTypeItem.DateEntered | date:'mediumDate') : 'N/A'
							}}</td>
						<td>{{ paymentTypeItem.DateUpdated ? (paymentTypeItem.DateUpdated | date:'mediumDate') : 'N/A'
							}}</td>

						<!-- Status -->
						<td class="text-center align-middle">
							<div class="flex justify-center items-center">
								<p-tag [value]="paymentTypeItem.IsActive === 1 ? 'Active' : 'Inactive'"
									[severity]="getPaymentTypeSeverity(paymentTypeItem.IsActive)"
									(click)="togglePaymentTypeStatus(paymentTypeItem, true)">
								</p-tag>
							</div>
						</td>

						<!-- Approved -->
						<td class="text-center align-middle">
							<div class="flex justify-center items-center">
								<p-tag
									[value]="paymentTypeItem.IsApproved === 1 ? (translateServ.dictionary['APPROVED'] || 'Approved') : (translateServ.dictionary['NOT_APPROVED'] || 'Not Approved')"
									[severity]="paymentTypeItem.IsApproved === 1 ? 'success' : 'warning'"
									(click)="togglePaymentTypeStatus(paymentTypeItem, false)">
								</p-tag>
							</div>
						</td>

						<!-- Actions -->
						<td class="text-center align-middle">
							<div class="flex justify-center gap-2 items-center">
								<button pButton icon="pi pi-pencil" (click)="editPaymentType(paymentTypeItem)"
									class="p-button-rounded p-button-text p-button-sm"
									[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']"></button>
								<button pButton icon="pi pi-trash" (click)="confirmDelete(paymentTypeItem)"
									class="p-button-rounded p-button-text p-button-sm"
									[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
								</button>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</ng-container>

	<!-- NO DATA -->
	<ng-template #noPaymentTypes>
		<div class="text-center p-4">
			<i class="pi pi-credit-card text-400" style="font-size: 3rem"></i>
			<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_NO_DATA_MSG_PAYMENT'] }}</p>
		</div>
	</ng-template>
</ng-container>